import { ReactNode, useEffect } from 'react'

import { Grid, Span } from 'components'
import { ExpandIcon } from 'components/Icons'
import useToggle from 'hooks/useToggle'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

import {
  CardContentStyled,
  CardStyled,
  CollapseInfo,
  CollapseStyled
} from './styles'

interface SimpleCollapseProps {
  title: string
  isOpen?: boolean
  setIsOpen?: React.Dispatch<boolean>
  textColor?: string
  subtitle?: string
  children?: ReactNode
  isExpanded?: boolean
  isGeneratePDF?: boolean
}

const SimpleCollapse = ({
  title,
  subtitle,
  textColor,
  isOpen,
  setIsOpen,
  children,
  isGeneratePDF,
}: SimpleCollapseProps) => {
  const [expanded, toggleExpand] = useToggle(true)

  // useEffect(() => {
  //   if (isExpanded) {
  //     toggleExpand()
  //   }
  // }, [isExpanded])

  useEffect(() => {
    if (isGeneratePDF && !expanded) {
      toggleExpand()
    }
  }, [isGeneratePDF])

  return (
    <CardStyled elevation={3}>
      <CardContentStyled isHeader>
        <CollapseInfo>
          <Grid gridCols="50% 48% 2%">
            <Span
              marginLeft={SPACING.spacing10}
              text={title}
              color={textColor || COLORS.blueFonts}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              marginTop={SPACING.spacing5}
              text={subtitle ? subtitle : ' '}
              color={COLORS.black}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
              textAlign="right"
              marginRight={SPACING.spacing20}
            />
            <ExpandIcon
              isExpanded={!expanded}
              onClick={setIsOpen ?? toggleExpand}
            />
          </Grid>
        </CollapseInfo>
      </CardContentStyled>
      <CollapseStyled in={isOpen ?? expanded} timeout="auto" unmountOnExit>
        <CardContentStyled>{children}</CardContentStyled>
      </CollapseStyled>
    </CardStyled>
  )
}

export default SimpleCollapse
